/**
 * Handles video and 3D model playback for product media
 * Works with native slider-component (no Swiper dependency)
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Listen for slider changes from the child slider-component
    const sliderComponent = this.querySelector('slider-component');

    if (sliderComponent) {
      sliderComponent.addEventListener('slideChanged', (event) => {
        const currentSlide = event.detail.currentElement;
        if (currentSlide) {
          window.pauseAllMedia();
          this.playMedia(currentSlide);
        }
      });
    }

    // Scroll to the selected variant's image on page load
    this.scrollToSelectedVariant();
  }

  /**
   * Scrolls to the initially selected variant's image on page load
   * Mimics the old Swiper initialSlide behavior
   */
  scrollToSelectedVariant() {
    const selectedSlide = this.querySelector('slider-component')?.slider?.querySelector('[data-selected-image]');
    if (!selectedSlide) return;

    selectedSlide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'start' });
  }

  /**
   * Scrolls to and activates the media item with the specified media ID
   * @param {string} mediaId - The media ID to scroll to
   */
  setActiveMedia(mediaId) {
    const slider = this.querySelector('slider-component')?.slider;
    const targetSlide = slider?.querySelector(`[data-media-id="${mediaId}"]`);
    if (!targetSlide) return;

    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    window.pauseAllMedia();
    this.playMedia(targetSlide);
  }

  playMedia(activeSlide) {
    const deferredMedia = activeSlide.querySelector('.deferred-media');

    if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
      deferredMedia.loadContent(false);
    } else {
      activeSlide.querySelectorAll(".js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "playVideo" + '","args":""}',
          "*"
        );
      });
      activeSlide.querySelectorAll(".js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"play"}', "*");
      });
      activeSlide.querySelectorAll("video").forEach((video) => video.play());
      activeSlide.querySelectorAll("product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.play();
      });
    }
  }
}

customElements.define('product-media', ProductMedia);
